module.exports = __webpack_public_path__ + "Flag-678.0fd0ae7f6a0d740ae673d0876396ba0e.svg";